<template>
  <div
    class="w-auto h-auto collapse navbar-collapse max-height-vh-100 h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item" >
         <div class="text-center">
           <p v-if="user" class="text-uppercase text-dark font-weight-bold mb-0">{{user.name}}</p>
           <p v-if="user" class="text-lowercase text-sm">{{user.email}}</p>
         </div>
      </li>
      <li class="nav-item" v-if="$userCan(['administrator','supervisor_ftd','supervisor_retention','agent_retention', 'agent_ftd'])">
        <sidenav-collapse navText="Inicio" :to="{ name: 'dashboard' }" @click="toggleSidebar">
          <template #icon>
            <shop />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="$userCan('administrator')">
        <sidenav-collapse navText="Usuarios" :to="{ name: 'users' }" @click="toggleSidebar">
          <template #icon>
            <office />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="$userCan(['administrator','supervisor_ftd','supervisor_retention','agent_retention', 'agent_ftd'])">
        <sidenav-collapse navText="Enviar SMS" :to="{ name: 'sms' }" @click="toggleSidebar">
          <template #icon>
            <credit-card />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="$userCan(['administrator','supervisor_ftd','supervisor_retention','agent_retention', 'agent_ftd'])">
        <sidenav-collapse navText="Lista de SMS" :to="{ name: 'sms-list' }" @click="toggleSidebar">
          <template #icon>
            <document />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="$userCan(['administrator','supervisor_ftd','supervisor_retention'])">
        <sidenav-collapse navText="App SMS 3P" :to="{ name: 'sms-messages' }" @click="toggleSidebar">
          <template #icon>
            <spaceship />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="$userCan(['administrator'])">
        <sidenav-collapse navText="Configuración" :to="{ name: 'configuration' }" @click="toggleSidebar">
          <template #icon>
            <Settings/>
          </template>
        </sidenav-collapse>
      </li>
    </ul>
  </div>
  <div class="sidenav-footer">
    <a
      class="btn bg-gradient-success mt-4 w-100"
      @click="logout"
      type="button"
      >Cerrar Sesión</a
    >
  </div>
</template>
<script>
import SidenavCollapse from "./SidenavCollapse.vue";
import Shop from "../../components/Icon/Shop.vue";
import Office from "../../components/Icon/Office.vue";
import CreditCard from "../../components/Icon/CreditCard.vue";
import Spaceship from "../../components/Icon/Spaceship.vue";
import Document from "../../components/Icon/Document.vue";
import {decrypt} from "@/utils/encrypt";
import routerList from "@/router/index"
import {get} from "@/utils/httpRequest";
import {mapActions, mapMutations} from "vuex";
import Settings from "@/components/Icon/Settings.vue";
export default {
  name: "SidenavList",
  props: {
    cardBg: String,
  },
  data : () => ({
    title: "Pagos",
    controls: "",
    isActive: "active",
    arrayOptions: [
        {key:'dashboard', name: ''},
      'users','transactions','leads', 'clients'],
    arrayMenu: [],
    user_id: null,
    user: null
  }),
  components: {
    Settings,
    SidenavCollapse,
    Shop,
    Office,
    CreditCard,
    Spaceship,
    Document
  },
  mounted() {
    this.getMenu()
    this.user_id = localStorage.getItem('payment-admin-uuid')
    setTimeout(()=>{
      this.getProfile()
    },500)
  },
  methods: {
    ...mapMutations(["navbarMinimize", "toggleConfigurator"]),
    ...mapActions(["toggleSidebarColor"]),
    toggleSidebar() {
      if (window.innerWidth < 991) {
        this.toggleSidebarColor("bg-white");
        this.navbarMinimize();
      }
    },
    getMenu(){
      const storage = localStorage.getItem('payment-admin-type')
      setTimeout(()=>{
        const rol = decrypt(storage)
        const router = routerList.options.routes;
        this.arrayOptions.forEach(el => {
          router.forEach(item=> {
            if(item.name === el){
              if(item.meta.roles.includes(rol)){
                this.arrayMenu.push(el)
              }
            }
          })
        })
      },500)
    },
    async getProfile(){
      const {data} = await get(`users/find-one?id=${this.user_id}`, null)
      data.password = ''
      this.user = data
    },
    logout() {
      localStorage.clear()
      this.$router.push('/')
    }
  },
};
</script>
